import React from "react"
import Layout from "../components/Layout"
import SEO from "../components/SEO"
import { graphql } from "gatsby"
import Projects from "../components/Projects"

const ProjectsPage = ({
  data:{allProject:{nodes:projects}}
}) => {

  return (
      <Layout>
        <SEO title="Projects | Nishant Tiwari" />
        <section className="projects-page">
          <Projects projects = {projects} title="all projects"/>
        </section>
      </Layout>

    )
}


export const query = graphql`
  {
    allProject {
      nodes {
        id
        slug
        description
        title
        links {
          label
          url
        }
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
        stack_icons {
          name
          icon {
            childImageSharp {
              fixed(height: 20) {
                ...GatsbyImageSharpFixed_withWebp_tracedSVG
              }
            }
          }
        }
      }
    }
  }
`

export default ProjectsPage
